import React, { useState } from "react";
import {
	Alert,
	Container, Row, Col,
	Card, CardBody, CardGroup,
	Form, FormGroup,
	Input, InputGroup, InputGroupAddon,
	Label, 
} from "reactstrap";
import { LoginButton } from './LoginButton';
import ModalRegistration from '../Registration/ModalRegistration';
import style from './Login.module.scss'


export default function Login({
	isLoading, error, username, onUsernameChange, password, onPasswordChange, onSubmit
}) {
	const [modal, setModal] = useState(false)
	const [showPwd, setShowPwd] = useState(false)

	return (
			<div className="app flex-row align-items-center">
				<Container style={{backgroundColor:"transparent"}}>
					<Row className="justify-content-center">
						<Col md="8">
							<CardGroup className="mb-0">
								<Card className="p-4">
									<CardBody className="card-body">
										<img
											style={{
												width: "50%", display: "block",
												marginLeft: "auto",
												marginRight: "auto"
											}}
											src={ // imposta file del logo: img/logo.png | img/logo-test.png
												require("img/logo.png")}
											alt="magico login"
										/>
										<Form onSubmit={onSubmit}>
											{error && <Alert color="danger">{error}</Alert>}
											<FormGroup className="mb-3">
												<Label for={"username"}>Email</Label>
												<Input type="text" id={"username"}
												       placeholder="Username" value={username}
												       onChange={onUsernameChange} required/>
											</FormGroup>
											<FormGroup className="mb-4">
												<Label for={"password"}>Password</Label>
												<InputGroup>
													<Input className={style['passwordField']}
														type={showPwd ? "text" : "password"}
														id={"password"}
														placeholder="Password"
														value={password}
														onChange={onPasswordChange} required
													/>
													<InputGroupAddon addonType="append" className={style['eyeBox']}
														onClick={() => setShowPwd(a => !a)}
													>
														<i className={showPwd ? "fa fa-eye-slash" : "fa fa-eye"} aria-hidden="true"></i>
													</InputGroupAddon>
												</InputGroup>
											</FormGroup>
											<Row>
												<Col xs="6">
													<LoginButton primary className="px-4"
													             isLoading={isLoading}>Login</LoginButton>
												</Col>
											</Row>
										</Form>
									</CardBody>
								</Card>
							</CardGroup>
						</Col>
					</Row>
				</Container>
				<ModalRegistration
					isOpen={modal}
					toggleSignUpModal={() => setModal(a => !a)}
					title={"Radom sign-up"}
					message={"Enter your details to create a Radom account"}
				/>
			</div>
	)
}
